export default "/images/6a88e4aaa834c61537e0ce41f9009d97.avif";